import { Injectable } from '@angular/core';
import axios from "axios";
import Axios, { AxiosInstance } from "axios";
import { ErrorHandler } from "@angular/core";
import * as moment from 'moment';
import {Logger} from './chatbot-logger.service'
import {IPayloadToWatson,IWelcomeMessage} from "./interfaces"
export interface Params {
	[ key: string ]: any;
}
 
export interface GetOptions {
	url: string;
	params?: Params;
}

export interface LoginOptions {
  method:string;
  instanceId:string;
	url: string;
	params?: Params;
}
 
export interface ErrorResponse {
	id: string;
	code: string;
	message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ChatbotHttpClientService {
  private token:string = null
  private serverUrl: string
  private version: string
  private axiosClient: AxiosInstance;
  private errorHandler: ErrorHandler;
  
  private payloadToWatson:IPayloadToWatson;
 
  private loginOptions: LoginOptions
  private txStartTimestamp:string
  private txEndTimestamp:string
  private isLoginTx:Boolean 
  // I initialize the ApiClient.
  
	constructor( errorHandler: ErrorHandler) {
 
		this.errorHandler = errorHandler;
    
		// The ApiClient wraps calls to the underlying Axios client.
		this.axiosClient = axios.create({
			timeout: 3000,
			headers: {
				"X-Initialized-At": Date.now().toString()
			}
		});
 
	}
 
	// ---
	// PUBLIC METHODS.
	// ---
 
  public init(){

  }

  public setOptions( version: string ):void{
    this.version = version
  }
  
  public async makeLogin( options: LoginOptions ) : Promise<IWelcomeMessage> {
    this.serverUrl = options.url
    this.loginOptions = options
    this.txStartTimestamp = moment().toISOString()
    this.isLoginTx = true

    let axiosResponse = null

		try {
      if (this.token == null){
        
        Logger.info("Runnning NG login...")

        axiosResponse = await axios.post(`${this.serverUrl}/login`,options.params)
        
        this.txEndTimestamp = moment().toISOString()
        Logger.info(`CH:HTTP:Initial config message: ${JSON.stringify(axiosResponse.data)}`)
        this.token = axiosResponse.data.token

        let {isChatbotSecured,logLevel,isChatbotMaximized,securePin,runtimeMode,instance,token,...welcomeMessage} = axiosResponse.data
        
        this.token = token

        return( Promise.resolve(welcomeMessage) );
      }
		} catch ( error ) {
      Logger.error(`NG login failed: ${JSON.stringify(error)}`)
			return( Promise.reject() );
		}
 
  }
  
  public async makeQuestion( payload: IPayloadToWatson ) : Promise<Object> {
    
		try {
      if (this.token != null){
        
        payload.txStartTimestamp = this.txStartTimestamp
        payload.txEndTimestamp = this.txEndTimestamp
        payload.isLoginTx = this.isLoginTx

        let httpOptions = {
          headers: { 'content-type': 'application/json' ,
                      'opus-sec-token': this.token
        
          }
        }
        Logger.info(`CH:HTTP:API request: ${JSON.stringify(payload)}`)

        this.txStartTimestamp = moment().toISOString()
        Logger.info(`CH:HTTP:API tx start timestamp: ${this.txEndTimestamp}`)
        this.isLoginTx = false
        
        let axiosResponse = await axios.post(`${this.serverUrl}/message`,payload, httpOptions)
        this.txEndTimestamp = moment().toISOString()
        Logger.info(`CH:HTTP:API tx end timestamp: ${this.txEndTimestamp}`)
        Logger.info(`CH:HTTP:API response: ${JSON.stringify(axiosResponse.data)}`)
        return( axiosResponse.data );
      } else {
        //zavolat login a znovu ?
        Logger.error(`CH:HTTP:API no token availabe -> trying to re-login`)
        if (this.loginOptions){
          Logger.info(`CH:HTTP:trying re-login with: ${JSON.stringify(this.loginOptions)}`)
          await this.makeLogin(this.loginOptions)
          return 'relogin'
     
        } else {
          Logger.error(`CH:HTTP:API no loginOptions available`)
          return( 'relogin-err' );
        }

      }
		} catch ( error ) {
      Logger.error(`CH:HTTP:API unexpected error: ${JSON.stringify(error)}`)
			return( "unexpected-err" );
 
		}
 
  }
  
 
}
